<template>
    <div>
        <hts-modal
            :show="openModal"
            :title="$t('labels.taskSetting')"
            @hide="hide">
            <hts-form
                class="space-y-6 mt-5"
                @submit="saveCondition">
                <div
                    v-for="(condition, index) in conditions"
                    :key="index"
                    class="grid grid-cols-9 gap-3">
                    <hts-form-select
                        v-model="condition.index"
                        v-model:text="condition.name"
                        class="col-span-2"
                        :label="$t('labels.position')"
                        :items="positionItemSelect"
                        key-id="index"
                        key-label="namePosition"
                        required
                        name="position"
                        :prop="`position_${index}`"
                        @change="(val: any) => handleSelectPosition(val, index)" />
                    <hts-form-select
                        v-model="condition.task"
                        v-model:text="condition.taskName"
                        :label="$t('labels.task')"
                        :items="condition.position?.tasks || []"
                        key-id="task"
                        required
                        name="task"
                        :prop="`task_${index}`"
                        key-label="taskName"
                        class="col-span-2" />
                    <hts-form-select
                        v-model="condition.condition"
                        v-model:text="condition.conditionName"
                        :label="$t('labels.condition')"
                        :items="conditionItemSelect"
                        key-id="condition"
                        name="condition"
                        :prop="`condition_${index}`"
                        required
                        key-label="conditionName"
                        class="col-span-2" />
                    <hts-system-select-task
                        v-model="condition.taskCondition"
                        v-model:text="condition.taskConditionName"
                        :label="$t('labels.job')"
                        key-id="_id"
                        key-label="name"
                        required
                        :name="condition.condition ? (condition.condition === 'pre' ? 'taskPre' : 'taskPost') : 'task'"
                        :prop="`taskCondition_${index}`"
                        :show-business="false"
                        task-type="NO_AFFECT_SHIPPING_TIME"
                        class="col-span-2" />

                    <div class="w-full h-full flex justify-center items-center">
                        <hi-x-circle-icon
                            class="h-6 w-6 mt-8 text-error-500 hover:text-error-700 cursor-pointer"
                            @click="($event: any )=> deleteCondition($event, index)" />
                    </div>
                </div>

                <hts-form-button
                    class="mt-5"
                    icon-name="hi-plus-icon"
                    icon-position="left"
                    color="info"
                    size="small"
                    type="button"
                    :outline="false"
                    @click="addCondition">
                    {{ $t('labels.add') }}
                </hts-form-button>

                <div class="flex justify-end mt-5 gap-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        type="submit"
                        color="info"
                        :outline="false">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </hts-form>
        </hts-modal>
    </div>
</template>
<script setup lang="ts">
import { $lodash } from '#imports'
import event = google.maps.event

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['update'])

const disabled = toRefs(props)
const openModal = ref(false)
const defaultCondition = {
  index: '',
  name: '',
  task: '',
  taskName: '',
  condition: '',
  conditionName: '',
  taskCondition: '',
  taskConditionName: '',
  position: {} as { [key: string]: any }
}

const conditions = ref<{ [key: string]: any }[]>([{ name: '' }])
const positions = ref<{ [key: string]: any }[]>([])
const open = (conditionVal: { [key: string]: any }[], positionsVal: { [key: string]: any }[]) => {
  conditions.value = conditionVal?.length ? $lodash.cloneDeep(conditionVal) : [$lodash.cloneDeep(defaultCondition)]
  positions.value = $lodash.cloneDeep(positionsVal)
  openModal.value = true
}

const positionItemSelect = computed(() => {
  return positions.value.map((position) => {
    const namePosition = `Vị trí ${position.index} - ${position.nodeLocationName}`

    return { index: position.index, namePosition, position }
  })
})

const addCondition = () => {
  if (!conditions.value.length) {
    resetField()
    return
  }

  conditions.value.push($lodash.cloneDeep(defaultCondition))
}

const deleteCondition = (e: Event, index: number) => {
  e.preventDefault()
  e.stopPropagation()

  if (!conditions.value[index]) {
    return
  }
  conditions.value.splice(index, 1)
}

const handleSelectPosition = (positions: { [key: string]: any }[], index: number) => {
  if (!conditions.value || !conditions.value.length) {
    resetField()
    return
  }

  if (!conditions.value[index]) {
    return
  }

  conditions.value[index].position = positions?.[0]?.position || {}
  conditions.value[index].task = ''
  conditions.value[index].taskName = ''
}

const resetField = () => {
  conditions.value = [$lodash.cloneDeep(defaultCondition)]
}

const hide = () => {
  openModal.value = false
}

const conditionItemSelect = [
  {
    condition: 'pre',
    conditionName: $t('labels.pre')
  },
  {
    condition: 'post',
    conditionName: $t('labels.post')
  }
]

// const rules = computed(() => {
//   const results = {} as {[key: string]: string}
//
//   if (!conditions.value.length) {
//     return results
//   }
//
//   for (let i = 0; i < conditions.value.length; i++) {
//     results[`position_${i}`] = 'required'
//     results[`task_${i}`] = 'required'
//     results[`condition_${i}`] = 'required'
//     results[`taskCondition_${i}`] = 'required'
//   }
//
//   return results
// })

const saveCondition = () => {
  hide()
  emits('update', $lodash.cloneDeep(conditions.value))
  resetField()
}

defineExpose({ open, hide })
</script>
